import React from 'react';
import { connect } from 'react-redux';
import { fromJS } from 'immutable';

import Supplies from '../Supplies';

const mapStateToProps = ({
  dialog: {
    contentProps: {
      current,
      original
    },
  },
  connectedUser
}) => ({
  current,
  original,
  user: connectedUser,
});

class SuppliesDialog extends React.Component {
  state = {
    current: this.props.current,
    original: this.props.original
  }

  setInter = (path, value, cb = f => f) => {
    const { original } = this.state;
    const current = this.state.current;
    current[path] = value;
    this.setState({ current, original }, cb);
  };

  render() {
    const { current } = this.state;
    const { user } = this.props;
    return (
      <Supplies
        merge={fromJS(current)}
        setData={this.setInter}
        value={fromJS(current.supplies)}
        user={user}
        expanded
      />
    );
  }
}

export default connect(mapStateToProps)(SuppliesDialog);
